import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { toggleClass } from '@fretadao/f-js-dom';

import tippy from 'tippy.js';
import 'tippy.js/themes/light.css';
import 'tippy.js/dist/tippy.css';

application.register('b2b-admin-arrivals-and-departures', class extends Controller {
  static targets = ['list', 'form'];
  static values = { slug: String };

  connect() {
    setTimeout(() => this.submitForm(), 30000);
    tippy('.tooltip');
  }

  submitForm() {
    if (!this.hasFormTarget) return;

    this.formTarget.requestSubmit();
    setTimeout(() => this.submitForm(), 30000);
  }

  toggleList() {
    toggleClass(this.listTarget, 'hidden');
  }
});
